import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './screens/Dashboard';
import { ContentFactory } from './screens/ContentFactory';
import { Channels } from './screens/Channels';
import { Exchange } from './screens/Exchange';
import { Analytics } from './screens/Analytics';
import { Farm } from './screens/Farm';
import { Bots } from './screens/Bots';
import { Settings } from './screens/Settings';
import { Billing } from './screens/Billing';
import { Login } from './screens/Login';
import { PublicChannelPage } from './screens/PublicChannelPage';
import { OnboardingWizard } from './screens/OnboardingWizard';
import { AdminLayout } from './screens/admin/AdminLayout';
import { AdminDashboard } from './screens/admin/AdminDashboard';
import { AdminUsers } from './screens/admin/AdminUsers';
import { AdminPayments } from './screens/admin/AdminPayments';
import { AdminHealth } from './screens/admin/AdminHealth';
import AdminRisks from './screens/admin/AdminRisks';
import AdminTelegramAccounts from './screens/admin/AdminTelegramAccounts';
import AdminConfig from './screens/admin/AdminConfig';
import { useAuth } from './auth/AuthProvider';

function ProtectedRoute({ children }: { children: React.ReactNode }): JSX.Element {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Загрузка…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }): JSX.Element {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Загрузка…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/public/channel/:handle" element={<PublicChannelPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="content" element={<ContentFactory />} />
        <Route path="channels" element={<Channels />} />
        <Route path="exchange" element={<Exchange />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="farm" element={<Farm />} />
        <Route path="bots" element={<Bots />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<Billing />} />
        <Route path="onboarding" element={<OnboardingWizard />} />
      </Route>
      <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
        <Route index element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="health" element={<AdminHealth />} />
        <Route path="risks" element={<AdminRisks />} />
        <Route path="telegram-accounts" element={<AdminTelegramAccounts />} />
        <Route path="config" element={<AdminConfig />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
